/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CategorySalesfor1997AddComponent
 * Purpose		: This component retrieves specified record and shows details.
 * Dependency	: CategorySalesfor1997Service
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { Component, OnInit, HostBinding, EventEmitter, Input, Output,
         trigger, transition, animate,
         style, state } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/switchMap';
import { ToastsManager }  from 'ng2-toastr';
import { CategorySalesfor1997Data, CategorySalesfor1997Service }  from './CategorySalesfor1997.service';


@Component({
  template: require('./CategorySalesfor1997Details.component.html'),
  providers: [CategorySalesfor1997Service
	
	],
  animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.2s ease-in')
      ]),
      transition(':leave', [
        animate('0.5s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class CategorySalesfor1997DetailsComponent implements OnInit {
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}

	// @HostBinding('style.position') get position() {
	//  return 'absolute';
	// }

	objCategorySalesfor1997: CategorySalesfor1997Data;
	errorMessage: string;
	messages: string[];

	// Lookup Arrays
	

	constructor(private route: ActivatedRoute, 
		private router: Router,
		private toastr: ToastsManager,
		private CategorySalesfor1997Service: CategorySalesfor1997Service

	) {
		// this.id = parseInt(params.get('id'));
		this.objCategorySalesfor1997 = new CategorySalesfor1997Data();
	}

	ngOnInit() {
		this.route.params
		// (+) converts string 'id' to a number
		// .switchMap((params: Params) => this.CategorySalesfor1997Service.getByID(+params['id']))
		.switchMap((params: Params) => this.CategorySalesfor1997Service.getByID(params['id']))
		.subscribe((item: CategorySalesfor1997Data) => this.objCategorySalesfor1997 = item);
		this.getLookups();
	}

	deleteCategorySalesfor1997(id: string) {
		if (window.confirm('Are you sure you want to delete this CategorySalesfor1997?') == true) 
		{
			this.CategorySalesfor1997Service.deleteCategorySalesfor1997(this.objCategorySalesfor1997.CategoryName.toString())
			.subscribe(record => this.router.navigate(['/CategorySalesfor1997']),
				error =>  this.errorMessage = 'There was an error while deleting record. Error: ' + <any>error,
				() => { console.log('CategorySalesfor1997 record deleted successfully...'); }
			);
		}
	}
	gotoCategorySalesfor1997Edit() {
		this.router.navigate(['/CategorySalesfor1997', this.objCategorySalesfor1997.CategoryName]);
	}

	gotoCategorySalesfor1997() {
		this.router.navigate(['/CategorySalesfor1997']);
	}


	getLookups() {

	}

	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/CategorySalesfor1997/CategorySalesfor1997Details.component.ts